module.exports = __webpack_public_path__ + "static/media/passStyleEventTicket.ff1b90a8.svg";